import { Action } from "../../../actions/actions";
import { HomeActionTypes } from "../actions/actionTypes";
import { Route } from "../../../api/apiTypes";
import { SubAppConfig } from "../../../reducers/subAppsConfig.reducer";

export function activeSubApps(
    state: SubAppConfig[] = [],
    action: Action
): SubAppConfig[] {
    switch (action.type) {
        case HomeActionTypes.UPDATE_ACTIVE_SUBAPPS:
            return action.payload;
        default:
            return state;
    }
}
